import { ServiceCodeBySystem, IntegrationSystem } from '@/shared/types';

import { config } from '@/config/index';

import { RouteConfig } from '@/router/types';

export const WNT_ROUTES: Record<keyof ServiceCodeBySystem<IntegrationSystem.WNT>, RouteConfig> = {
  MISSING_PASSPORT: { basePath: config.router.servicePath, path: 'missing-passport', isPrivate: false },
  MISSING_PHONE: { basePath: config.router.servicePath, path: 'missing-phone', isPrivate: false },
  WANTED_WEAPON: { basePath: config.router.servicePath, path: 'wanted-weapon', isPrivate: false },
  WANTED_ART: { basePath: config.router.servicePath, path: 'wanted-art', isPrivate: false },
  MISSING_INCAPACITATED_PERSONS: {
    basePath: config.router.servicePath,
    path: 'missing-incapacitated-persons',
    isPrivate: false,
  },
  MISSING_CORPSES: { basePath: config.router.servicePath, path: 'missing-corpse', isPrivate: false },
  WANTED_PERSON_SEARCH: { basePath: config.router.servicePath, path: 'wanted-person-search', isPrivate: false },
  MISSING_PERSON_SEARCH: { basePath: config.router.servicePath, path: 'missing-person-search', isPrivate: false },
  MISSING_CHILDREN_SEARCH: { basePath: config.router.servicePath, path: 'missing-children-search', isPrivate: false },
  VEHICLE_SEARCH: { basePath: config.router.servicePath, path: 'vehicle-search', isPrivate: false },
  CHECK_EXTRACT_VERIFICATION: {
    basePath: config.router.servicePath,
    path: 'check-extract-verification',
    isPrivate: false,
  },
};
